import script from "./Expert.vue?vue&type=script&setup=true&lang=js"
export * from "./Expert.vue?vue&type=script&setup=true&lang=js"

import "./Expert.vue?vue&type=style&index=0&id=79782389&lang=scss&scoped=true"

import exportComponent from "/var/www/html/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-79782389"]])

export default __exports__